<template>
  <div class="row">
    <div class="col-12">
      <div class="card shadow-sm">
        <DetailHeader :headerTitle="'접속 이력 상세'" />

        <div class="pt-3 pb-5 d-flex justify-content-center">
          <!-- 로딩 -->
          <div v-if="loading">
            <TableBodyLoader :minHeight="815" :offsetY="-50" message="상세정보를 불러오는 중..." />
          </div>

          <!-- 내용 -->
          <div v-else class="w-100 px-5" style="min-height: 815px;">
            <!-- 기본 정보 -->
            <div class="log-section mb-3">
              <div class="log-title">기본 정보</div>
              <div class="log-kv">
                <div v-for="(row, i) in baseRows" :key="'b' + i" class="kv-row">
                  <div class="k">{{ row[0] }}</div>
                  <div class="v">{{ row[1] ?? '-' }}</div>
                </div>
              </div>
            </div>

            <!-- 요청 헤더 -->
            <div class="log-section">
              <div class="log-title">요청 헤더</div>
              <div class="log-kv">
                <div v-for="(row, i) in headerRows" :key="'h' + i" class="kv-row">
                  <div class="k">{{ row[0] }}</div>
                  <div class="v">{{ row[1] ?? '-' }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- // 내용 -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DetailHeader from "@/components/DetailHeader.vue";
import TableBodyLoader from "@/components/loading/TableBodyLoader.vue";
import api from "@/api/api";

export default {
  name: "WebLogDetail",
  components: { DetailHeader, TableBodyLoader },
  data() {
    return {
      loading: false,
      log: {},
    };
  },
  computed: {
    id() {
      return decodeURIComponent(this.$route.params.id);
    },
    // ✅ 그리드에 넣을 (키, 값) 튜플들
    baseRows() {
      const l = this.log || {};
      return [
        ["ID", l.webLogId],
        ["OCCRRNC_DE", l.occrrncDe],
        ["CREAT_DT", this.fmt(l.creatDt)],
        ["USER_ID", l.userId],
        ["MF ID", l.mfId],
        ["IP", l.ip],
        ["METHOD", l.httpMethod],
        ["SCREEN", l.screenNm],
        ["URL", l.url],
      ];
    },
    headerRows() {
      const l = this.log || {};
      return [
        ["Host", l.host],
        ["User-Agent", l.userAgent],
        ["Referer", l.referer],
        ["Accept-Language", l.acceptLang],
        ["Request-Id", l.reqId],
        ["X-Forwarded-For", l.forwardedFor],
      ];
    },
  },
  async mounted() {
    await this.fetchDetail();
  },
  methods: {
    async fetchDetail(minMs = 500) {
      this.loading = true;
      try {
        const [res] = await Promise.all([
          api.get("/webLog", { params: { id: this.id } }),
          new Promise((r) => setTimeout(r, minMs)),
        ]);
        this.log = res?.data?.result?.webLog || {};
      } catch (e) {
        this.toastError?.("상세 조회 중 오류가 발생했습니다.");
      } finally {
        this.loading = false;
      }
    },
    fmt(iso) {
      if (!iso) return "-";
      const d = new Date(iso);
      if (Number.isNaN(d.getTime())) return String(iso);
      const p = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
    },
  },
};
</script>

<style scoped>
.card { border: 1px solid rgba(0,0,0,.06) !important; }

.log-section { background: #fff; overflow: hidden; }
.log-title { font-weight: 700; padding: .5rem .1rem; color: #344767; }

/* ✅ 키/값 그리드: 열 맞춤 + 줄바꿈 */
.log-kv {
  background: #0b1020;
  color: #f9fafb;
  border-radius: .5rem;
  padding: 1rem;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace;
  font-size: 13px;
  line-height: 1.55;
}

.kv-row {
  display: grid;
  grid-template-columns: 150px 1fr; /* 왼쪽 키 고정폭 */
  column-gap: 12px;
  align-items: start;
  padding: .15rem 0;
}

.k {
  color: #aeb7d0;
  white-space: nowrap;       /* 키는 한 줄 유지 */
}

.v {
  white-space: pre-wrap;     /* 값은 줄바꿈 허용 */
  overflow-wrap: anywhere;   /* 긴 토큰/URL 강제 개행 */
  word-break: break-word;    /* 한글도 안전 개행 */
}

/* 좁은 화면에서 키 열 폭 축소 */
@media (max-width: 992px) {
  .kv-row { grid-template-columns: 180px 1fr; }
}
@media (max-width: 768px) {
  .kv-row { grid-template-columns: 150px 1fr; }
}
@media (max-width: 576px) {
  .kv-row { grid-template-columns: 120px 1fr; }
}
</style>
